<!-- 左边资源的列表 -->
<template>
  <div class="PageLeftResource">
    <!-- 头部的视频预览 -->
    <div class="PreviewTop">
      <div class="PreviewTitle">
        {{ $t('lang.Viewer') }}
        <span>{{videoName}}</span>
      </div>
      <div class="PreviewBox">
        <video v-show="PreviewSwitch" id="videoMp8" disablePictureInPicture :featuresFullscreenResize="true" x5-playsinline="" playsinline="" webkit-playsinline="" class="videoTv video-js vjs-default-skin vjs-big-play-centered" controls="controls" name="media" muted="muted" preload="auto" notSupportedMessage="此视频暂无法播放，请稍后再试">
          <source :src="videoSrc" type="video/mp4" />
        </video>
        <!-- <video-module
          v-if="!PreviewSwitch"
          :height="'228px'"
          :width="'400px'"
          :source="socketData"
          deviceType="T"
          :rid="socketData.livePeerId"
          :oldReceiverInfoObj="socketData"
          :oldGetKernelStateObj="socketData"
          :useOldR="false"
          :sid="socketData.peerId"
          :status="socketData.status"
        /> -->
        <div :class="['ejectIcon',{'ejectIconZ':!PreviewSwitch}]" @click="EjectIcon">
          <i class="iconfont icon-eject"></i>
        </div>
      </div>
    </div>
    <!-- 中间横线 -->
    <div class="transverseLine">
    </div>
    <!-- 下面的资源展示 -->
    <div class="BottomResource">
      <div class="LeftClassify">
        <div v-for="(item,index) in ClassifyList" :key="index">
          <div :class="['SortChunk',{'PitchSortChunk':PitchClass == item.type}]" @click="selectChunk(item)" v-if="!(WhichPage == 'Playout' && !item.switch)">
            <div>
              <i :class="['iconfont',item.icon]"></i>
              <p>{{$t(item.name)}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="RightResourceList">
        <public-file-tree v-if="PitchClass == 'Media'" :renderNode="renderNode" @SetPreviewVideo="SetPreviewVideo"></public-file-tree>
        <source-list v-if="PitchClass == 'Live Source'" :FilterBookmark="bookmark" @SetPreviewVideo="SetPreviewVideo"></source-list>
        <program-template-list v-if="PitchClass == 'Program Template'" @editTemplate="editTemplate"></program-template-list>
        <Schedule-template-list v-if="PitchClass == 'Schedule Template'" @editTemplate="editTemplate"></Schedule-template-list>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import PublicFileTree from '@/components/common/PublicFileTree.vue'
import SourceList from '@/components/file/SourceList.vue'
import ProgramTemplateList from '@/components/file/ProgramTemplateList.vue'
import ScheduleTemplateList from '@/components/file/ScheduleTemplateList.vue'
import videoModule from '@/components/common/VideoC'
import { mapState } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
export default {
  props: {
    bookmark: {
      type: Array,
      default: () => []
    },
    // 存在哪个页面
    WhichPage: {
      type: String,
      default: 'Playout' // Scheduler和Playout 分别是两个页面
    }
  },
  watch: {
    // 监听导航
    PitchClass (newdata, olddata) {
      if (olddata == 'Program Template') {
        this.editTemplate({
          status: false,
          name: 'programTemplate'
        })
      }
    }
  },
  data () {
    return {
      // 左边类别列表
      ClassifyList: [
        {
          name: 'lang.Media',
          icon: 'icon-video1',
          switch: true,
          type: 'Media'
        },
        {
          name: 'lang.LiveSource',
          icon: 'icon-Live',
          switch: true,
          type: 'Live Source'
        },
        {
          name: 'lang.programTemplate',
          icon: 'icon-template',
          switch: true,
          type: 'Program Template'
        },
        {
          name: 'lang.scheduleTemplate',
          icon: 'icon-calendar',
          switch: false,
          type: 'Schedule Template'
        }
      ],
      // 选中的类别
      PitchClass: 'Media',
      // 视频的url
      videoSrc: '',
      // 视频名字
      videoName: '',
      // source对应的r的信息
      SourceLiveR: {
        id: '',
        type: ''
      },
      // r的信息
      selectR: {},
      // 选中source正在live的信息
      socketData: {},
      // 两种预览开关
      PreviewSwitch: true,
      // 刷新树形文件夹
      renderNode: 0
    }
  },
  components: {
    PublicFileTree,
    SourceList,
    ProgramTemplateList,
    ScheduleTemplateList
  },
  computed: {
    ...mapState({
      pageRWebsocket: (state) => state.websocket.pageRWebsocket
    })
  },
  created () {
    this.initialPlay({
      directory: true,
      id: 'b8033031e72b44e189e6b81805e50a7c',
      name: 'Make your stories come alive',
      type: 'Video',
      url: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
      videoTimes: '3600',
      videoUrls: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
      visible: true
    })
  },
  mounted () {
  },
  methods: {
    initialPlay (data) {
      this.$nextTick(() => {
        const vdo = document.getElementById('videoMp8')
        if (vdo) {
          vdo.src = data.url
          vdo.pause()
          vdo.load()
          vdo.play()
          this.videoSrc = data.url
          this.videoName = data.name
        }
      })
    },
    selectChunk (item) {
      this.PitchClass = item.type
      if (item.type == 'Live Source') {
        playoutAnalyze('welcomeSelectLiveSourceTab')
      }
      if (item.type == 'Media') {
        playoutAnalyze('welcomeSelectMediaTab')
      }
      if (item.type == 'Program Template') {
        playoutAnalyze('welcomeSelectProgramTemplateTab')
      }
      if (item.type == 'Schedule Template') {
        playoutAnalyze('welcomeSelectScheduleTemplateTab')
      }
    },
    currentSelectData (item) {
      this.selectR = JSON.parse(JSON.stringify(item))
      this.$emit('currentSelectData', item)
      Bus.$emit('playOutVideoR', item)
    },
    // 清空视频播放
    EjectIcon () {
      // 视频预览清除
      const vdo = document.getElementById('videoMp8')
      if (vdo) {
        vdo.src = ''
        this.videoSrc = ''
      }
      this.videoName = ''
      this.SourceLiveR = {
        id: '',
        type: ''
      }
      this.socketData = {}
      // source预览清除
      this.PreviewSwitch = true
      this.EndSchedulerWebsocket()
    },
    // 编辑模板
    editTemplate (item) {
      this.$emit('editTemplate', item)
    },
    // 设置预览视频
    SetPreviewVideo (data, type) {
      console.log(data)
      if (type == 'Media') {
        this.PreviewSwitch = true
        const vdo = document.getElementById('videoMp8')
        if (vdo) {
          vdo.src = data.url
          vdo.pause()
          vdo.load()
          vdo.play()
          this.videoSrc = data.url
          this.videoName = data.name
        }
        this.EndSchedulerWebsocket()
      } else {
        let livePeerId = ''
        // 判断是live还是在线的SDI
        if (data.status == 2) {
          livePeerId = data.livePeerId
          this.SourceLiveR.type = ''
        } else if (data.status == 1 && data.peerId.length == 32) {
          const SDIpeerId = [data.peerId.substr(0, 16), data.peerId.substr(16, 16)]
          // 判断是否是SDI连接
          if (SDIpeerId[1] == '0000000000000002') {
            livePeerId = SDIpeerId[0]
            this.SourceLiveR.type = 'SDI'
          }
        }
        // livePeerId没有值即不能预览
        if (!livePeerId) {
          this.$message.error(this.$t('lang.noSupportView'))
          this.EjectIcon()
          this.EndSchedulerWebsocket()
          return
        }
        this.socketData = {}
        this.videoName = data.name
        this.SourceLiveR.id = livePeerId
        if (!this.PreviewSwitch) {
          this.PreviewSwitch = true
          this.$nextTick(() => {
            this.PreviewSwitch = false
          })
        } else {
          this.PreviewSwitch = false
        }
        // 判断是scheduler页面
        if (this.WhichPage == 'Scheduler') {
          this.EndSchedulerWebsocket()
          this.SchedulerPreview(livePeerId)
        }
      }
    },
    // scheduler页面预览的websocket
    SchedulerPreview (rid) {
      this.pageRWebsocket.send({
        message: { rid, categoryId: '2152857600', operationType: '102' },
        time: 1000,
        isOnce: false,
        key: 'getQueryKennel',
        success: (res) => {
          const data = res.data ? JSON.parse(res.data) : {}
          if (res.rid == rid) {
            data.SDI = this.SourceLiveR.type == 'SDI'
            this.socketData = data
          }
        }
      })
    },
    // 结束scheduler页面的websocket
    EndSchedulerWebsocket () {
      // 判断是scheduler页面
      if (this.WhichPage == 'Scheduler') {
        if (this.pageRWebsocket) {
          this.$createWebsocket.pageRWebsocket('stop', 'getQueryKennel')
        }
      }
    },
    // 查询当前r的信息
    async getRMessage (param) {
      await this.axios.get(`/ccp/tvucc-device/device/getDevice?peerId=${param}`).then((res) => {
        if (res.data.errorCode == '0x0') {
          console.log(res.data)
          return true
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      })
    }
  },
  beforeDestroy () {
    Bus.$off('SourcePreview')
    Bus.$off('BehaviorChange')
    // 两个页面统一一个地方清除r的监听
    Bus.$off('playOutVideoR')
    this.EndSchedulerWebsocket()
  }
}
</script>

<style scoped lang="less">
.PageLeftResource {
  border-right: 1px solid #252525;
  .PreviewTop {
    padding: 15px 16px;
    text-align: left;
    .PreviewTitle {
      display: flex;
      margin-bottom: 8px;
      span{
        display: inline-block;
        width: 340px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .PreviewBox {
      position: relative;
      video {
        width: 400px;
        height: 228px;
      }
      .ejectIcon {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 28px;
        height: 28px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        text-align: center;
        line-height: 28px;
        i {
          margin-top: -3px;
        }
      }
      .ejectIconZ{
        z-index:  2000;
      }
    }
  }
  .transverseLine {
    width: 432px;
    height: 2px;
    background-color: #252525;
  }
  .BottomResource {
    height: 564px;
    display: flex;
    .LeftClassify {
      width: 80px;
      background: #333333;
      .SortChunk {
        width: 80px;
        height: 80px;
        background: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 24px;
          color: #666666;
        }
        p {
          width: 52px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
          margin: 0;
        }
      }
      .PitchSortChunk {
        background: #444444;
        i {
          color: #cccccc;
        }
        p {
          color: #cccccc;
        }
      }
    }
    .RightResourceList {
      width: 351px;
      background: #444444;
      padding: 0 7px 0 15px;
      /deep/ ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      /deep/ ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        background-color: rgb(233, 233, 233);
        opacity: 0.7;
      }
      /deep/ ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 5px;
        background: none;
      }
    }
  }
}
</style>
